import React, { useState, useEffect } from 'react';
import FiltersAccordionGroupBasic from 'scenes/FiltersAccordion/components/Group//GroupBasic';
import FiltersAccordionGroupTag from 'scenes/FiltersAccordion/components/Group/GroupTag';

import 'scenes/FiltersAccordion/components/Section/styles.css';

const FiltersAccordionTagsSection = props => {
  const {
    groups,
    title,
    selected,
    onSearch,
    sectionKey,
    disabled,
    onPushValue,
    onSelectAll,
    onResetToDefault,
    onChange,
    toggleFunc,
    toggleIndex,
    toggledIndex,
  } = props;

  const {
    tagType: { elements = [] },
  } = groups;
  const [toggled, setToggle] = useState(false);

  useEffect(() => {
    if (toggleIndex === toggledIndex && !toggled) {
      setToggle(true);
    } else if (toggleIndex !== toggledIndex) {
      setToggle(false);
    }
  }, [toggledIndex]);

  const toggleHandler = () => {
    setToggle(!toggled);
    toggleFunc(toggleIndex);
  };

  const handleSearchRequest = (groupKey, value) => {
    return onSearch(value, `${sectionKey}.${groupKey}`);
  };

  const handlePush = (groupKey, value) => {
    onPushValue(sectionKey, groupKey, value);
  };

  const handleChange = (groupKey, value) => {
    onChange(sectionKey, groupKey, value);
  };

  const handleSelectAll = groupKey => {
    onSelectAll(sectionKey, groupKey);
  };

  const handleClearAll = groupKey => {
    onResetToDefault(sectionKey, groupKey);
  };

  const clsCaptonSelected = selected
    ? ' filter-accordion__caption--selected'
    : '';
  const clsCaption =
    (toggled
      ? 'filter-accordion__caption filter-accordion__caption--toggled'
      : 'filter-accordion__caption') + clsCaptonSelected;

  const clsBody = toggled
    ? 'filter-accordion__body filter-accordion__body--open'
    : 'filter-accordion__body';

  const selectedGroups = elements
    .filter(el => el.selected === true)
    .map(el => parseInt(el.value));

  const filters = Object.keys(groups).map((key, index) => {
    const {
      title,
      tagTypeId,
      elements,
      type = key === 'tagType' ? 'tag' : 'default',
    } = groups[key];

    const visible = selectedGroups.indexOf(tagTypeId) !== -1;

    return {
      tag: (
        <FiltersAccordionGroupTag
          title={title}
          key={index}
          group={key}
          elements={elements}
          disabled={disabled}
          onChange={handleChange}
          onPushValue={handlePush}
          onSelectAll={handleSelectAll}
          onResetToDefault={handleClearAll}
          onSearchRequested={handleSearchRequest}
        />
      ),
      default: (
        <FiltersAccordionGroupBasic
          title={title}
          visible={visible}
          key={index}
          group={key}
          elements={elements}
          disabled={disabled}
          onChange={handleChange}
          onSelectAll={handleSelectAll}
          onResetToDefault={handleClearAll}
        />
      ),
    }[type];
  });

  return (
    <div className="filter-accordion">
      <div onClick={toggleHandler} className={clsCaption}>
        {title}
      </div>
      <div className={clsBody}>{filters}</div>
    </div>
  );
};

FiltersAccordionTagsSection.propTypes = {};

export default FiltersAccordionTagsSection;
